<ion-app>
  @if (loadingService.getLoading()) {
    <ion-progress-bar type="indeterminate" class="z-[100033]"></ion-progress-bar>
  }
  <router-outlet></router-outlet>
</ion-app>
